import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "gerenziliao"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "个人资料")], -1);

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  class: "panel-title"
};
const _hoisted_6 = {
  class: "panel-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
    data: $data.userinfo,
    border: "",
    small: "",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "user_id",
      label: "用户编号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "group_name",
      label: "级别",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "username",
      label: "账号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "username",
      label: "名称",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "balance",
      label: "彩票余额",
      align: "center"
    })]),
    _: 1
  }, 8, ["data"])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.gamesinfo, game => {
    return _openBlock(), _createElementBlock("div", {
      class: "panel",
      key: game.gname,
      style: {
        "margin": "10px 0"
      }
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("h2", null, _toDisplayString(game.gname), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_row, {
      gutter: 50
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(game.list, list => {
        return _openBlock(), _createBlock(_component_el_col, {
          key: list,
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: list,
            border: "",
            small: "",
            "highlight-current-row": "",
            "header-cell-class-name": "table-header-cell",
            "header-row-class-name": "table-header-row",
            "table-layout": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "name",
              label: "交易类型",
              align: "center"
            }), _ctx.$store.state.userinfo.level_id == 0 || _ctx.$store.state.userinfo.level_id == 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "water_break_A",
              label: "A盘退水",
              align: "center"
            }, {
              default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.water_break_A) + "%", 1)]),
              _: 1
            })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.level_id == 0 || _ctx.$store.state.userinfo.level_id == 2 ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "water_break_B",
              label: "B盘退水",
              align: "center"
            }, {
              default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.water_break_B) + "%", 1)]),
              _: 1
            })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.level_id == 0 || _ctx.$store.state.userinfo.level_id == 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "water_break_C",
              label: "C盘退水",
              align: "center"
            }, {
              default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.water_break_C) + "%", 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
              prop: "straightbet_high",
              label: "单注限额",
              align: "center"
            }), _createVNode(_component_el_table_column, {
              prop: "single_high",
              label: "单期限额",
              align: "center"
            })]),
            _: 2
          }, 1032, ["data"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 2
    }, 1024)])]);
  }), 128))]);
}